// AppRoutes.jsx

import React, { useEffect, useRef, useState } from 'react';
import { Routes, Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { getRole, getToken, getUserId } from '../Redux/selecters/index';
import { handleCurrency } from '../Redux/actions/currency';
import { createHubConnection, invokeLogin } from '../POS/services/signalRService';
import ApiService from '../POS/services/apiService';
import { saveLogin, setUserRole } from '../Redux/actions';
import userManagement from '../POS/services/userManagement';
import { SET_USER_ID } from '../Redux/actions/types';

// Layouts
import PlainLayout from '../POS/component/pages/SideBar/plainLayout';
import CashierLayout from '../POS/Cashier/components/cashierLayout';
import MainLayout from '../POS/component/pages/SideBar/mainLayout';
import MainInventoryLayout from '../INVENTORY/Layouts/mainLayout';

// Auth
import InventoryLogin from '../INVENTORY/Components/login/login';
import Signup from '../POS/component/pages/user/signup';
import KDSLogin from '../POS/component/pages/user/kdsLogin';

// Customer
import CustomerMenu from '../POS/Customer/Menu/customerMenu';
import AddtoCart from '../POS/Customer/Cart/cart';
import CardDetails from '../POS/Customer/Payment/cardDetails';
import WaitPage from '../POS/Customer/Payment/waitPage';
import ThirdParty from '../POS/Customer/thirdParty/thirdParty';
import CustomerCombo from '../POS/Customer/Combo/combo';

// Kitchen
import KitchenDisplay from '../POS/KDS/kitchenDisplay';
import KitchenHistory from '../POS/KDS/kitchenHistory';
import KitchenOrderDetail from '../POS/KDS/detail';

// Cashier
import CashierMenu from '../POS/Cashier/pages/cashierMenu';
import CounterSelector from '../POS/Cashier/components/counter/counterSelector';
import SwitchUserScreen from '../POS/Cashier/pages/openCash/swtichUserScreen';
import PaymentComponent from '../POS/Cashier/components/flocashPayment';
import OpeningCash from '../POS/Cashier/pages/openCash/openingCash';
import OpenCashList from '../POS/Cashier/pages/openCash/openCashList';
import DayCloseForm from '../POS/Cashier/components/DayClose/dayCloseForm';
import HandOvered from '../POS/Cashier/components/handOverForm/handOverList';
import Dispute from '../POS/Cashier/pages/dispute';
import HandOverForm from '../POS/Cashier/components/handOverForm/handOverform';
import PayIn from '../POS/Cashier/pages/payIn';
import PayOut from '../POS/Cashier/pages/payOut';
import PayInForm from '../POS/Cashier/components/PayIn_out_Form/payInForm';
import PayOutForm from '../POS/Cashier/components/PayIn_out_Form/payOutForm';
import DayOpeningForm from '../POS/Cashier/components/DayOpening/dayOpeningForm';
import DayOpeningList from '../POS/Cashier/components/DayOpening/DayOpeningList';
import WaiterCall from '../POS/Cashier/components/waiterCall/waiterCall';
import SaleHistory from '../POS/Cashier/components/saleHistory/saleHistory';
import PayLater from '../POS/Cashier/components/saleHistory/payLater';
import UpdateOrder from '../POS/Cashier/components/updateOrder/updateOrder';
import CashOrderDetail from '../POS/Cashier/components/saleHistory/cashOrderDetail';
import CardPayment from '../POS/Cashier/components/cashierPayment/cardPayment';
import Table from '../POS/Cashier/components/Table/table';
import NewReservation from '../POS/Cashier/components/Table/newReservation';
import Delivery from '../POS/Cashier/components/Delivery/Delivery';
import DeliveryList from '../POS/Cashier/components/Delivery/DeliveryList';

// Admin
import Dashboard from '../POS/component/pages/Dashboard/dashboard';
import Orders from '../POS/component/pages/orders/order';
import OrderDragNDrop from '../POS/component/pages/orders/orderD&D';
import SingleOrder from '../POS/component/pages/orders/singleOrder/singleOrder';
import Menu from '../POS/component/pages/menus/menu';
import ItemDetails from '../POS/component/pages/menus/itemDetails/itemDetail';
import ItemNavBar from '../POS/component/pages/menus/addItems/ItemNavBar';

// Customer Mgmt
import Costumer from '../POS/component/pages/AdminCustomer/customer';
import AddCostumer from '../POS/component/pages/AdminCustomer/AddCustomer';
import CostumerDetails from '../POS/component/pages/AdminCustomer/customerDetail';

// Employees
import Employee from '../POS/component/pages/Employees/employee';
import AddEmployee from '../POS/component/pages/Employees/createEmployee';
import EmployeeDetails from '../POS/component/pages/Employees/employeeDetails';

// Restaurant
import Restaurant from '../POS/component/pages/Restaurants/restaurant';
import CreateRestaurant from '../POS/component/pages/Restaurants/createRestaurant';
import CreateBranch from '../POS/component/pages/Restaurants/createBranch';

// Master
import AddCategory from '../POS/component/pages/master/addCategory';
import AddSubCategory from '../POS/component/pages/master/createSubCategory';
import AddVarients from '../POS/component/pages/master/variants';
import CreateModifier from '../POS/component/pages/menus/addItems/createModifiers';
import CreateAddOn from '../POS/component/pages/menus/addItems/createAddOn';
import AddCombos from '../POS/component/pages/menus/addItems/createCombo';
import UploadFile from '../POS/component/pages/master/uploadFile';
import AddCurrency from '../POS/component/pages/master/currencyManagment/currencyManagment';
import CurrencyDetail from '../POS/component/pages/master/currencyManagment/currencyDetail';
import TaxManagment from '../POS/component/pages/master/taxManagment';
import AdminMaster from '../POS/component/pages/menus/addItems/createMenuItem';
import UpdateMenuItem from '../POS/component/pages/menus/addItems/updateMenuItem';
import TableMaster from '../POS/component/pages/master/tableMaster/tableMaster';
import KitchenMaster from '../POS/component/pages/master/kitchenMaster/kitchenMaster';
import CreateMethod from '../POS/component/pages/master/paymentMethodMaster/createMethod';
import CreateDiscount from '../POS/component/pages/master/discountMaster/discountMaster';
import PromotionMaster from '../POS/component/pages/master/promotionMaster/promotionMaster';
import UserClaim from '../POS/component/pages/master/userRolesMaster/userClaim';
import UserRole from '../POS/component/pages/master/userRolesMaster/userRole';
import UserMaster from '../POS/component/pages/master/userMaster/userMaster';
import ManageUsers from '../POS/component/pages/master/userMaster/manageUser';
import EditUserRole from '../POS/component/pages/master/userMaster/editUserRole';
import EditRoleRights from '../POS/component/pages/master/userMaster/editRoleRights';
import ManageRoles from '../POS/component/pages/master/userMaster/manageRole';
import AddItemsMaster from '../POS/component/pages/master/ItemMaster/itemMaster';
import BrandMaster from '../POS/component/pages/master/brandMaster/brandMaster';
import MasterPage from '../POS/component/pages/master/masterPage/masterPage';
import AreaMaster from '../POS/component/pages/master/areaMaster/areaMaster';
import CreateCounter from '../POS/component/pages/master/counterMaster/counterMaster';
import DeliveryPlatforms from '../POS/component/pages/master/deliveryPlatforms/createDPlatforms';
import MarchaintMaster from '../POS/component/pages/master/MarchantMaster/merchantMaster';
import TerminalMaster from '../POS/component/pages/master/terminalMaster/terminalMaster';

// Settings
import Notification from '../POS/component/pages/setting/Notification';
import PasswordReset from '../POS/component/pages/setting/user';
import CurrencySetting from '../POS/component/pages/setting/currency';
import TaxSetting from '../POS/component/pages/setting/taxsetting';
import ThemeSetting from '../POS/component/pages/setting/themeSetting';

// Payment
import PaymentManagment from '../POS/component/pages/payment/paymentManagment';

// Reports
import ReportsPage from '../POS/component/pages/master/masterPage/reportsPage';
import ReportsDashboard from '../POS/component/pages/reports/dashboard/reportsDashboard';
import ReportGrid from '../POS/component/pages/reports/Grid/reportGrid';
import TotalOrder from '../POS/component/pages/reports/totalOrder';
import SaleSummeryReport from '../POS/component/pages/reports/saleReport/saleSummeryReport';
import ThirdPartReport from '../POS/component/pages/reports/thirdPartReport/thirdPartReport';
import ThirdPartyGrid from '../POS/component/pages/reports/thirdPartReport/thirdPartyGrid';
import DeliveryReport from '../POS/component/pages/reports/Delivery/DeliveryReport';
import TaxReport from '../POS/component/pages/reports/taxReport/taxReport';
import CashReport from '../POS/component/pages/reports/CashInOut/cashInOut';
import TableReport from '../POS/component/pages/reports/table/tableReport';
import XReceipt from '../POS/component/pages/reports/xReport/xReport';
import ZReport from '../POS/component/pages/reports/xReport/zReport';
import CZReport from '../POS/Cashier/components/Reports/zReport';

import CategorySaleReport from '../POS/component/pages/reports/categorySale/categorySaleReport';
import CashierSaleReport from '../POS/component/pages/reports/saleReport/cashierSaleReport';
import PaymentSaleReport from '../POS/component/pages/reports/saleReport/paymentSaleReport';
import CustomerReport from '../POS/component/pages/reports/customerReport/customerReport';
import ItemSaleReport from '../POS/component/pages/reports/itemSale/itemSaleReport';
import SaleTaxReport from '../POS/component/pages/reports/saleReport/taxReport';
import ShiftOpen from '../POS/component/pages/reports/shiftReports/shiftReports';
import DayReports from '../POS/component/pages/reports/shiftReports/dayReports';

// Other
import PostingPOS from '../POS/component/posting/posting';
import LandingPage from '../POS/LandingPage/landingPage';
import NotFoundPage from '../POS/LandingPage/notFound/notFound';
import ItemBulkUpload from '../POS/component/pages/master/BulkUpload/itemBulkUpload';
import SalesSummaryReport from '../POS/component/pages/reports/saleReport/salesTotal';
import SalesByHourReport from '../POS/component/pages/reports/saleReport/salesHourReport';
import ProfitMarginReport from '../POS/component/pages/reports/saleReport/profitMargin';
import BestWorstSalesReport from '../POS/component/pages/reports/saleReport/best&worstSale';
import SalesTaxReport from '../POS/component/pages/reports/saleReport/salesTaxSummary';
import DailySalesSummaryReport from '../POS/component/pages/reports/saleReport/dailySaleReport';
import PurchaseTaxReport from '../POS/component/pages/reports/saleReport/purchaseSaleSummary';
import FlashSaleReport from '../POS/component/pages/reports/saleReport/flashSaleReport';
import StockChangeReport from '../POS/component/pages/reports/saleReport/stockChangeReport';
import StockCheckByBranch from '../POS/Cashier/pages/stockCheckreport';
import ExpiryReport from '../POS/component/pages/reports/saleReport/expiryReport';
import AllBranchSaleReport from '../POS/component/pages/reports/saleReport/allBranchSaleReport';
import AllSalesOrder from '../POS/component/pages/reports/saleReport/allSalesOrder';
import GiftCardMaster from '../POS/component/pages/master/giftCardMaster/giftcardMaster';
import GiftCardDetails from '../POS/component/pages/master/giftCardMaster/giftCardDetails';
import GiftCardRedeemPanel from '../POS/Cashier/components/GiftCardCheck';
import BrandSaleReport from '../POS/component/pages/reports/saleReport/brandSaleReport';
import GiftCardReport from '../POS/component/pages/reports/saleReport/giftCardReport';
import CategorySaleReportCashier from '../POS/component/pages/reports/categorySale/categorySaleReportCashier';
import ItemSaleReportCashier from '../POS/component/pages/reports/itemSale/itemSaleReportCashier';
import StorePredctiviteReport from '../POS/component/pages/reports/saleReport/StorePredctiviteReport';
import UnsoldItem from '../POS/component/pages/reports/UnsoldItem/unsoldItem';
import TotalProductSaleQtyReport from '../POS/component/pages/reports/totalProductSaleQty/totalProductSaleQtyReport';

/* =========================================================
   Loader
========================================================= */
const Loader = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: 18,
      background: '#f5f5f5',
      color: '#666',
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 24, marginBottom: 10 }}>🔄</div>
      Loading…
    </div>
  </div>
);

/* =========================================================
   ✅ Clear storage ONLY when LAST TAB is closed
   - DOES NOT clear on refresh
   - Clears localStorage + CacheStorage on next fresh open
========================================================= */
const STORAGE_ACTIVE_TABS = '__POS_ACTIVE_TABS__';
const STORAGE_SHOULD_CLEAR = '__POS_SHOULD_CLEAR__';
const SESSION_TAB_ID = '__POS_TAB_ID__';

const safeParse = (v, fallback) => {
  try {
    return JSON.parse(v);
  } catch {
    return fallback;
  }
};
// useConfirmLogoutOnTabClose.js

const getNavType = () => {
  try {
    const nav = performance.getEntriesByType?.('navigation')?.[0];
    if (nav?.type) return nav.type; // 'navigate' | 'reload' | 'back_forward' | 'prerender'
  } catch {}
  try {
    return performance?.navigation?.type === 1 ? 'reload' : 'navigate';
  } catch {}
  return 'navigate';
};

const clearAllClientStorage = () => {
  try {
    localStorage.clear();
  } catch {}
  try {
    sessionStorage.clear();
  } catch {}

  // CacheStorage best-effort
  try {
    if ('caches' in window) {
      caches
        .keys()
        .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
        .catch(() => {});
    }
  } catch {}

  // Cookies (non-HttpOnly)
  try {
    document.cookie.split(';').forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
  } catch {}
};

/**
 * ✅ Confirm + logout ONLY on TAB CLOSE
 * ❌ Not on reload
 * ❌ Not on SPA route changes
 *
 * Usage:
 * useConfirmLogoutOnTabClose({ enabled: true, logoutRedirectUrl: LOGOUT_REDIRECT_URL });
 */
export function useConfirmLogoutOnTabClose({ enabled, logoutRedirectUrl }) {
  useEffect(() => {
    if (!enabled) return;

    // If the user is reloading, NEVER confirm/logout
    const navType = getNavType();
    if (navType === 'reload') return;

    // We’ll mark "closing" only when page is actually being discarded.
    // "pagehide" is the most reliable signal for tab close / bfcache.
    const onPageHide = (e) => {
      // If page is being put into back/forward cache, don't logout.
      if (e?.persisted) return;

      // IMPORTANT: we don't want to logout on normal SPA navigations;
      // pagehide fires when leaving the document (tab close / full navigation away).
      // If your app never does full navigations internally, this is safe.

      // Native confirm prompt: only possible via beforeunload.
      // pagehide is too late to show a prompt, so we use beforeunload for prompt
      // and pagehide for actual clear+redirect if user confirmed.
    };

    // This flag will be set only if user confirms leaving.
    let userConfirmedLeave = false;

    const onBeforeUnload = (e) => {
      // ✅ Not on reload
      if (getNavType() === 'reload') return;

      // If you also want to avoid prompt on external navigation (link to another site),
      // you can't perfectly distinguish; browser treats them similarly.
      // But your request is "tab close only"—best effort is:
      // show prompt only when the page is being closed (visibility/pagehide combo),
      // however browsers don't expose a perfect "tab close" signal.

      // We can do a best-effort heuristic: if the page is currently visible and
      // the user triggers beforeunload without any SPA navigation, prompt.
      userConfirmedLeave = true;

      e.preventDefault();
      e.returnValue = ''; // triggers native "Leave site?" prompt
      return '';
    };

    // If user confirmed leaving, this runs on actual teardown.
    const finalize = () => {
      if (!userConfirmedLeave) return;
      clearAllClientStorage();
      if (logoutRedirectUrl) {
        // use replace to avoid back button returning to app
        window.location.replace(logoutRedirectUrl);
      }
    };

    // Use both: beforeunload for prompt, pagehide for final cleanup
    window.addEventListener('beforeunload', onBeforeUnload);
    window.addEventListener('pagehide', finalize);

    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      window.removeEventListener('pagehide', finalize);
    };
  }, [enabled, logoutRedirectUrl]);
}

const clearLocalAndCache = async () => {
  try {
    localStorage.clear();
  } catch {}

  // Cache Storage (PWA / SW)
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {}
};
const useClearOnLastTabClose = () => {
  useEffect(() => {
    const navType = getNavType();

    // Unique per-tab id (sessionStorage survives refresh, disappears when tab closes)
    let tabId = sessionStorage.getItem(SESSION_TAB_ID);
    if (!tabId) {
      tabId = crypto?.randomUUID?.() ?? `${Date.now()}_${Math.random()}`;
      sessionStorage.setItem(SESSION_TAB_ID, tabId);
    }

    const readTabs = () => safeParse(localStorage.getItem(STORAGE_ACTIVE_TABS) || '[]', []);
    const writeTabs = (tabs) => localStorage.setItem(STORAGE_ACTIVE_TABS, JSON.stringify(tabs));

    const tabsNow = readTabs();
    const shouldClear = localStorage.getItem(STORAGE_SHOULD_CLEAR) === '1';

    // ✅ Only clear on a "fresh open" after the last tab was closed
    // ✅ Never clear on reload
    if (shouldClear && tabsNow.length === 0 && navType !== 'reload') {
      // Clear everything now; app will redirect to login due to missing Token
      clearLocalAndCache();
      return;
    }

    // Register this tab as active
    if (!tabsNow.includes(tabId)) writeTabs([...tabsNow, tabId]);

    // If reload set SHOULD_CLEAR by mistake, remove it now
    localStorage.removeItem(STORAGE_SHOULD_CLEAR);

    const unregister = () => {
      try {
        const tabs = readTabs().filter((id) => id !== tabId);
        writeTabs(tabs);

        // if this was the last tab, set the flag
        if (tabs.length === 0) {
          localStorage.setItem(STORAGE_SHOULD_CLEAR, '1');
        }
      } catch {}
    };

    // pagehide is best, unload is fallback
    window.addEventListener('pagehide', unregister);
    window.addEventListener('unload', unregister);

    return () => {
      window.removeEventListener('pagehide', unregister);
      window.removeEventListener('unload', unregister);
    };
  }, []);
};

/* =========================================================
   ✅ ProtectedRoute (fixed)
   - DOES NOT clear localStorage on refresh
   - Uses redux token OR localStorage token fallback
========================================================= */
function ProtectedRoute({ allowedRoles, children, requireCashierAccess = false }) {
  const role = useSelector(getRole);
  const reduxToken = useSelector(getToken);
  const location = useLocation();

  // ✅ fallback: token can exist in localStorage after refresh
  const token = reduxToken || localStorage.getItem('Token');

  if (!token) {
    localStorage.clear();
    window.location.href = 'https://app.pro360erp.com/';
    return null;
  }

  if (!role) return <Loader />;

  if (!allowedRoles.includes(role)) {
    return (
      <Navigate to={role === 'Cashier' || role === 'Waiter' ? '/cashier/home' : role === 'Admin' ? '/home' : '/login'} state={{ from: location }} replace />
    );
  }

  // Admin needs explicit cashier access
  if (requireCashierAccess && role === 'Admin') {
    const hasCashierAccess = localStorage.getItem('HasCashierAccess') === 'true';
    if (!hasCashierAccess) return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

/* ---- helpers for branchId (from GET_EMPLOYEE) ---- */
const extractBranchId = (emp) =>
  emp?.res_Branch_Id ?? emp?.BranchId ?? emp?.branchId ?? emp?.BranchID ?? emp?.branchID ?? emp?.branchNo ?? emp?.branch?.id ?? null;

const ensureBranchInLocal = (employeeLike) => {
  const bid = extractBranchId(employeeLike);
  if (bid != null) localStorage.setItem('BranchId', String(bid));
  return bid != null;
};

/* =========================================================
   AppRoutes
========================================================= */
const AppRoutes = () => {
  const LOGOUT_REDIRECT_URL = 'https://app.pro360erp.com/';

  const getNavType = () => {
    // modern browsers
    try {
      const nav = performance.getEntriesByType?.('navigation')?.[0];
      if (nav?.type) return nav.type; // 'navigate' | 'reload' | 'back_forward' | 'prerender'
    } catch {}

    // fallback older browsers
    try {
      // 1 === TYPE_RELOAD
      return performance?.navigation?.type === 1 ? 'reload' : 'navigate';
    } catch {}

    return 'navigate';
  };

  const clearAllClientStorage = () => {
    try {
      localStorage.clear();
    } catch {}
    try {
      sessionStorage.clear();
    } catch {}

    // CacheStorage (async best effort)
    try {
      if ('caches' in window) {
        caches
          .keys()
          .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
          .catch(() => {});
      }
    } catch {}

    // IndexedDB (async best effort)
    try {
      if (indexedDB?.databases) {
        indexedDB
          .databases()
          .then((dbs) => {
            dbs.forEach((db) => {
              if (db?.name) {
                try {
                  indexedDB.deleteDatabase(db.name);
                } catch {}
              }
            });
          })
          .catch(() => {});
      }
    } catch {}

    // Cookies (non-HttpOnly only)
    try {
      document.cookie.split(';').forEach((cookie) => {
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      });
    } catch {}
  };

  useEffect(() => {
    const onStorage = (e) => {
      // when Token removed OR localStorage.clear() happens => e.key can be null
      if (e.key === 'Token' || e.key === null) {
        if (!localStorage.getItem('Token')) {
          window.location.href = LOGOUT_REDIRECT_URL;
        }
      }
    };

    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  useClearOnLastTabClose();
  // Enable confirm+logout on close/refresh/navigation away
  useConfirmLogoutOnTabClose({
    enabled: true,
    logoutRedirectUrl: LOGOUT_REDIRECT_URL,
  });

  const role = useSelector(getRole);
  const token = useSelector(getToken);
  const userid = useSelector(getUserId);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isInitializing, setIsInitializing] = useState(true);
  const [isEnsuringBranch, setIsEnsuringBranch] = useState(false);
  const initRef = useRef(false);
  const apiService = new ApiService();

  /* ---------- MAIN INITIALIZATION ---------- */
  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    const initialize = async () => {
      try {
        const urlParams = checkUrlParameters();
        if (urlParams) {
          await handleUrlLogin(urlParams);
          return;
        }

        const existingToken = localStorage.getItem('Token');
        if (!existingToken) {
          localStorage.clear();
          window.location.href = 'https://app.pro360erp.com/';
          return;
        }

        const userRole = userManagement.getUserRole(existingToken);

        if (userRole) {
          dispatch(setUserRole(userRole));

          // ✅ userId is derived from token
          const userIdFromToken = await userManagement.getUserId(existingToken);
          if (userIdFromToken) {
            dispatch({ type: SET_USER_ID, payload: userIdFromToken });
            invokeLogin(userIdFromToken);
          }

          const currentPath = location.pathname;
          if (currentPath === '/' || currentPath === '/login') {
            await navigateToRoleHome(userRole, userIdFromToken);
          }
        } else {
          localStorage.clear();
          window.location.href = 'https://app.pro360erp.com/';
        }
      } catch (error) {
        localStorage.clear();
        window.location.href = 'https://app.pro360erp.com/';
      } finally {
        setIsInitializing(false);
      }
    };

    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ---------- URL PARAM HELPERS ---------- */
  const checkUrlParameters = () => {
    const url = window.location.href;
    const regex = /_username=([^&]+)&_password=([^&]+)&_db=([^&]+)&_baseDb=([^&]+)/;
    const match = url.match(regex);
    if (match) {
      const [, username, password, db, baseDb] = match;
      if (username && password && db && baseDb) return { username, password, db, baseDb };
    }
    return null;
  };

  const handleUrlLogin = async (params) => {
    try {
      const body = {
        email: params.username,
        password: params.password,
        basedb: params.baseDb,
        supportdb: params.db,
      };
      localStorage.setItem('LoginParams', JSON.stringify(body));
      const response = await apiService.post('GET_ENCRYPT_TOKEN', body);

      if (response?.status === 200 && response?.data?.data?.accessToken) {
        const userData = response.data.data;

        // ====== STORE TOKENS ======
        localStorage.setItem('Token', userData.accessToken);
        localStorage.setItem('RefreshToken', userData.refreshToken);

        // ====== STORE COMPANIES ======
        const companies = userData.userCompanies || [];
        localStorage.setItem('userCompanies', JSON.stringify(companies));

        // ====== STORE ACTIVE DB ======
        if (userData.dataDb) localStorage.setItem('activeDB', userData.dataDb);

        const activeCompany = companies.find((c) => (c.dataDB || c.dataDb) === userData.dataDb);
        if (activeCompany?.companyNo) localStorage.setItem('selectedCompanyNo', String(activeCompany.companyNo));

        // ====== DISPATCH REDUX STATES ======
        dispatch(saveLogin(response.data));

        // ✅ Use token to derive userId
        const userIdFromToken = await userManagement.getUserId(userData.accessToken);
        if (userIdFromToken) dispatch({ type: SET_USER_ID, payload: userIdFromToken });

        const userRole = userManagement.getUserRole(userData.accessToken);
        dispatch(setUserRole(userRole));

        if (userIdFromToken) invokeLogin(userIdFromToken);

        cleanUrlParameters();

        toast.success('Login successful!');
        await navigateToRoleHome(userRole, userIdFromToken);
      } else {
        throw new Error('Invalid login response');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Login failed');
      localStorage.clear();
      window.location.href = 'https://app.pro360erp.com/';
    } finally {
      setIsInitializing(false);
    }
  };

  /* ---------- ROLE-BASED NAV (ensures BranchId when needed) ---------- */
  const navigateToRoleHome = async (userRole, currentUserId) => {
    switch (userRole) {
      case 'Admin':
        navigate('/home', { replace: true });
        break;

      case 'Cashier':
      case 'Waiter': {
        await ensureBranchIdForCashierFlow(currentUserId);

        const counterData = localStorage.getItem('Counter');
        let hasValidCounter = false;

        if (counterData) {
          try {
            const counter = JSON.parse(counterData);
            hasValidCounter = !!(counter?.counterId && (counter?.shiftId || counter?.dayId));
          } catch {
            localStorage.removeItem('Counter');
          }
        }

        navigate(hasValidCounter ? '/cashier/home' : '/cashier/counterselection', { replace: true });
        break;
      }

      case 'Inventory Manager':
        navigate('/inventory/dashboard', { replace: true });
        break;

      case 'Customer':
        navigate('/customer/menu', { replace: true });
        break;

      default:
        localStorage.clear();
        window.location.href = 'https://app.pro360erp.com/';
    }
  };

  // Call GET_EMPLOYEE, store BranchId, but only if not already set
  const ensureBranchIdForCashierFlow = async (currentUserId) => {
    if (localStorage.getItem('BranchId')) return;
    if (!currentUserId) return;

    setIsEnsuringBranch(true);
    try {
      const param1 = `?UserId=${currentUserId}`;
      const res = await apiService.getApiParamater('GET_EMPLOYEE', param1);

      const emp = res?.data?.result?.[0];
      const ok = ensureBranchInLocal(emp);
      if (!ok) console.warn('branchId not found in GET_EMPLOYEE response', emp);
    } catch (err) {
      console.error('GET_EMPLOYEE failed:', err);
    } finally {
      setIsEnsuringBranch(false);
    }
  };

  /* ---------- UTIL ---------- */
  const cleanUrlParameters = () => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('_username');
      url.searchParams.delete('_password');
      url.searchParams.delete('_db');
      url.searchParams.delete('_baseDb');
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      console.error('Error cleaning URL:', error);
    }
  };

  /* ---------- FETCH CURRENCY WHEN AUTHED ---------- */
  useEffect(() => {
    if (role && token) fetchCurrency();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, token]);

  const fetchCurrency = async () => {
    try {
      const param = '?UserToken=' + token;
      const res = await apiService.getApiParamater('GET_CURRENCY', param);
      const currency = res?.data?.result?.find((c) => c?.default === true);
      if (currency) dispatch(handleCurrency(currency));
    } catch (error) {
      console.error('Currency fetch error:', error);
    }
  };

  /* ---------- SIGNALR ---------- */
  useEffect(() => {
    if (!role || !token) return;

    const handleReceiveMessage = (_user, message) => {
      if (role === 'Admin' || role === 'Cashier' || role === 'Waiter') toast.success(message);
    };

    const handleReceiveAck = () => console.log('Received acknowledgment');

    const handleReceiveRejection = (user, message) => {
      if (role === 'Admin' || role === 'Cashier' || role === 'Waiter') {
        toast.error(`Rejection from ${user}: ${message}`);
      }
    };

    const hubConnection = createHubConnection(handleReceiveMessage, handleReceiveAck, handleReceiveRejection);
    return () => {
      if (hubConnection) hubConnection.stop();
    };
  }, [role, token]);

  /* ---------- AUTH CHECK ---------- */
  useEffect(() => {
    // ✅ Do NOT clear on refresh. Only redirect if truly no token.
    const finalToken = token || localStorage.getItem('Token');
    if (!isInitializing && !finalToken) {
      localStorage.clear();
      window.location.href = 'https://app.pro360erp.com/';
    }
  }, [token, isInitializing]);

  /* ---------- BACKFILL BRANCH ON DIRECT CASHIER/ADMIN LINKS ---------- */
  useEffect(() => {
    const needsBranch = (role === 'Cashier' || role === 'Waiter') && !localStorage.getItem('BranchId');
    if ((token || localStorage.getItem('Token')) && userid && needsBranch) {
      ensureBranchIdForCashierFlow(userid);
    }
  }, [location.pathname, role, token, userid]);

  if (isInitializing || isEnsuringBranch) return <Loader />;

  return (
    <Routes>
      {/* Public */}
      <Route
        path="/login"
        element={
          <PlainLayout>
            <InventoryLogin />
          </PlainLayout>
        }
      />
      <Route
        path="/signup"
        element={
          <PlainLayout>
            <Signup />
          </PlainLayout>
        }
      />

      {/* Landing with role redirect */}
      <Route
        path="/"
        element={
          token || localStorage.getItem('Token') ? (
            role === 'Admin' ? (
              <Navigate to="/home" replace />
            ) : role === 'Cashier' || role === 'Waiter' ? (
              <Navigate to="/cashier/home" replace />
            ) : role === 'Inventory Manager' ? (
              <Navigate to="/inventory/dashboard" replace />
            ) : role === 'Customer' ? (
              <Navigate to="/customer/menu" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          ) : (
            <PlainLayout>
              <LandingPage />
            </PlainLayout>
          )
        }
      />

      {/* Customer (Public) */}
      <Route
        path="/customer/menu"
        element={
          <PlainLayout>
            <CustomerMenu />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/menu/combo"
        element={
          <PlainLayout>
            <CustomerCombo />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/thirdparty"
        element={
          <PlainLayout>
            <ThirdParty />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/menu/cart"
        element={
          <PlainLayout>
            <AddtoCart />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/menu/cart/payment"
        element={
          <PlainLayout>
            <CardDetails />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/wait"
        element={
          <PlainLayout>
            <WaitPage />
          </PlainLayout>
        }
      />

      {/* Kitchen (Public) */}
      <Route
        path="/kitchen"
        element={
          <PlainLayout>
            <KDSLogin />
          </PlainLayout>
        }
      />
      <Route
        path="/kitchen/orders"
        element={
          <PlainLayout>
            <KitchenDisplay />
          </PlainLayout>
        }
      />
      <Route
        path="/kitchen/history"
        element={
          <PlainLayout>
            <KitchenHistory />
          </PlainLayout>
        }
      />
      <Route
        path="/kitchen/order/:id/:name"
        element={
          <PlainLayout>
            <KitchenOrderDetail />
          </PlainLayout>
        }
      />

      {/* Cashier / Waiter / Admin with branch-access → Counter selection */}
      <Route
        path="/cashier/counterselection"
        element={
          <ProtectedRoute allowedRoles={['Cashier', 'Waiter', 'Admin']} requireCashierAccess={true}>
            <PlainLayout>
              <CounterSelector />
            </PlainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/cashier/shiftopen"
        element={
          <PlainLayout>
            <OpeningCash />
          </PlainLayout>
        }
      />

      {/* Cashier app */}
      <Route
        path="/cashier/*"
        element={
          <ProtectedRoute allowedRoles={['Cashier', 'Waiter', 'Admin']} requireCashierAccess={true}>
            <CashierLayout>
              <Routes>
                <Route path="home" element={<CashierMenu />} />
                <Route path="/Z-Report" element={<CZReport />} />
                <Route path="" element={<CashierMenu />} />
                <Route path="StockCheckByBranch" element={<StockCheckByBranch />} />

                <Route path="switchuser" element={<SwitchUserScreen />} />
                <Route path="payment" element={<PaymentComponent />} />
                <Route path="GiftCardCheck" element={<GiftCardRedeemPanel />} />
                <Route path="opencashlist" element={<OpenCashList />} />
                <Route path="dayclose" element={<DayCloseForm />} />
                <Route path="dayopen" element={<DayOpeningForm />} />
                <Route path="dayopening" element={<DayOpeningList />} />
                <Route path="payin" element={<PayIn />} />
                <Route path="payout" element={<PayOut />} />
                <Route path="payinform" element={<PayInForm />} />
                <Route path="payoutform" element={<PayOutForm />} />
                <Route path="handovered" element={<HandOvered />} />
                <Route path="dispute" element={<Dispute />} />
                <Route path="handoverform" element={<HandOverForm />} />
                <Route path="waiterorders" element={<WaiterCall />} />
                <Route path="salehistory" element={<SaleHistory />} />
                <Route path="holdorders" element={<PayLater />} />
                <Route path="updateorder" element={<UpdateOrder />} />
                <Route path="orderdetails/:id" element={<CashOrderDetail />} />
                <Route path="cardpayment" element={<CardPayment />} />
                <Route path=":id" element={<Table />} />
                <Route path="tables/newreservation" element={<NewReservation />} />
                <Route path="deliveries" element={<Delivery />} />
                <Route path="delivery/list" element={<DeliveryList />} />
                <Route path="reports/category" element={<CategorySaleReportCashier />} />
                <Route path="reports/itemsale" element={<ItemSaleReportCashier />} />
              </Routes>
            </CashierLayout>
          </ProtectedRoute>
        }
      />

      {/* Admin (Protected) */}
      <Route
        path="/home"
        element={
          <ProtectedRoute allowedRoles={['Admin']}>
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/*"
        element={
          <ProtectedRoute allowedRoles={['Admin']}>
            <MainLayout>
              <Routes>
                <Route path="orders" element={<Orders />} />
                <Route path="ordersdnd" element={<OrderDragNDrop />} />
                <Route path="order/:id" element={<SingleOrder />} />
                <Route path="orderdetails/:id" element={<CashOrderDetail />} />

                <Route path="menu" element={<Menu />} />
                <Route path="menu/:name/:id" element={<ItemDetails />} />
                <Route path="additems" element={<ItemNavBar />} />

                <Route path="customerlist" element={<Costumer />} />
                <Route path="customer/:id" element={<CostumerDetails />} />
                <Route path="addcustomer" element={<AddCostumer />} />

                <Route path="employee" element={<Employee />} />
                <Route path="employee/:id" element={<EmployeeDetails />} />
                <Route path="addemployee" element={<AddEmployee />} />

                <Route path="company" element={<Restaurant />} />
                <Route path="company/create" element={<CreateRestaurant />} />
                <Route path="company/branch/create" element={<CreateBranch />} />

                <Route path="delivery/create" element={<DeliveryPlatforms />} />

                <Route path="payment" element={<PaymentManagment />} />
                <Route path="posting" element={<PostingPOS />} />

                <Route path="master/list" element={<MasterPage />} />
                <Route path="master/itemmaster/create" element={<AddItemsMaster />} />
                <Route path="master/create" element={<AdminMaster />} />
                <Route path="master/bulkItems" element={<ItemBulkUpload />} />
                <Route path="master/update/:id" element={<UpdateMenuItem />} />

                <Route path="itemmaster/addcategory" element={<AddCategory />} />
                <Route path="itemmaster/subcategory" element={<AddSubCategory />} />
                <Route path="itemmaster/variants" element={<AddVarients />} />
                <Route path="itemmaster/uploadfile" element={<UploadFile />} />
                <Route path="itemmaster/addsons" element={<CreateAddOn />} />
                <Route path="itemmaster/modifier" element={<CreateModifier />} />
                <Route path="itemmaster/combos" element={<AddCombos />} />
                <Route path="itemmaster/GiftCard" element={<GiftCardMaster />} />
                <Route path="gift-cards/:giftCardCode" element={<GiftCardDetails />} />

                <Route path="itemmaster/countermaster" element={<CreateCounter />} />
                <Route path="master/usermaster/manageuser" element={<ManageUsers />} />
                <Route path="master/usermaster/manageuser/:userId" element={<EditUserRole />} />
                <Route path="master/usermaster/managerole" element={<ManageRoles />} />
                <Route path="master/usermaster/managerole/:roleId" element={<EditRoleRights />} />
                <Route path="master/usermaster/:id" element={<UserMaster />} />
                <Route path="usermanagement/usermaster/userrole" element={<UserRole />} />
                <Route path="usermanagement/usermaster/userclaim" element={<UserClaim />} />

                <Route path="master/currencymanagement" element={<AddCurrency />} />
                <Route path="master/currency/:id" element={<CurrencyDetail />} />
                <Route path="master/taxmanagement" element={<TaxManagment />} />
                <Route path="master/paymentmethod" element={<CreateMethod />} />
                <Route path="master/table" element={<TableMaster />} />
                <Route path="master/kitchen" element={<KitchenMaster />} />
                <Route path="master/discount" element={<CreateDiscount />} />
                <Route path="master/promotion" element={<PromotionMaster />} />
                <Route path="master/area" element={<AreaMaster />} />
                <Route path="master/brand" element={<BrandMaster />} />
                <Route path="master/merchant" element={<MarchaintMaster />} />
                <Route path="master/terminal" element={<TerminalMaster />} />

                <Route path="setting/notification" element={<Notification />} />
                <Route path="setting/profile" element={<PasswordReset />} />
                <Route path="setting/currency" element={<CurrencySetting />} />
                <Route path="setting/tax" element={<TaxSetting />} />
                <Route path="setting/theme" element={<ThemeSetting />} />

                <Route path="reports/list" element={<ReportsPage />} />
                <Route path="reports/dashboard" element={<ReportsDashboard />} />
                <Route path="reports/grid" element={<ReportGrid />} />
                <Route path="reports/order" element={<TotalOrder />} />
                <Route path="reports/totalsale" element={<SaleSummeryReport />} />
                <Route path="reports/GiftCardReport" element={<GiftCardReport />} />

                <Route path="reports/stockcheck" element={<StockChangeReport />} />
                <Route path="reports/3rdparty/chart" element={<ThirdPartReport />} />
                <Route path="reports/3rdparty" element={<ThirdPartyGrid />} />
                <Route path="reports/delivery" element={<DeliveryReport />} />
                <Route path="reports/tax" element={<TaxReport />} />
                <Route path="reports/cash" element={<CashReport />} />
                <Route path="reports/table" element={<TableReport />} />
                <Route path="reports/xreport" element={<XReceipt />} />
                <Route path="reports/zreport" element={<ZReport />} />
                <Route path="reports/category" element={<CategorySaleReport />} />
                <Route path="reports/cashier" element={<CashierSaleReport />} />
                <Route path="reports/payment" element={<PaymentSaleReport />} />
                <Route path="reports/customer" element={<CustomerReport />} />
                <Route path="reports/itemsale" element={<ItemSaleReport />} />
                <Route path="reports/saletax" element={<SaleTaxReport />} />
                <Route path="reports/shift" element={<ShiftOpen />} />
                <Route path="reports/day" element={<DayReports />} />
                <Route path="reports/sales-summary" element={<SalesSummaryReport />} />
                <Route path="reports/BrandSale" element={<BrandSaleReport />} />

                <Route path="reports/FlashSummary" element={<FlashSaleReport />} />
                <Route path="reports/ItemExpirySummary" element={<ExpiryReport />} />
                <Route path="reports/sales-by-hour" element={<SalesByHourReport />} />
                <Route path="reports/sales-tax" element={<SalesTaxReport />} />
                <Route path="reports/stores-sale" element={<AllBranchSaleReport />} />
                <Route path="Reports/SalesByHour" element={<SalesByHourReport />} />
                <Route path="Reports/PredictiveInventory" element={<StorePredctiviteReport />} />
                <Route path="Reports/ProfitMargin" element={<ProfitMarginReport />} />
                <Route path="Reports/BestWorstSales" element={<BestWorstSalesReport />} />
                <Route path="Reports/DailySalesSummary" element={<DailySalesSummaryReport />} />
                <Route path="Reports/AllSaleReport" element={<AllSalesOrder />} />
                <Route path="Reports/PurchaseTax" element={<PurchaseTaxReport />} />
                <Route path="Reports/UnsoldItems" element={<UnsoldItem />} />
                <Route path="Reports/TotalProductSaleQty" element={<TotalProductSaleQtyReport />} />
              </Routes>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Inventory Manager (Protected) */}
      <Route
        path="/inventory/*"
        element={
          <ProtectedRoute allowedRoles={['Inventory Manager']}>
            <MainInventoryLayout>
              <Routes>{/* put inventory routes here */}</Routes>
            </MainInventoryLayout>
          </ProtectedRoute>
        }
      />

      {/* 404 */}
      <Route
        path="*"
        element={
          <PlainLayout>
            <NotFoundPage />
          </PlainLayout>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
